<template>
    <div :class="'mBottom ' + classType">
        <img v-if="classType=='light'" class="corange" src="@/assets/img/Group 138@3x.png" alt="">
        <img v-else class="corange" src="@/assets/img/Group 138-2@3x.png" alt="">
        <p>粤ICP备2022095222号-1</p>
    </div>
</template>

<script>
export default {
    name: 'mBottom',
    props:['classType'],
    data(){
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/base.scss";
    .mBottom {
        text-align: center;
        font-size: poToRem(12);
        color: rgba(255, 255, 255, 0.2);
        padding-top: poToRem(16);
        padding-bottom: poToRem(16);
        background: inherit;
        &.light {
            // background: #ffffff;
            color: rgba(0,0,0,0.1);
        }
        img {
            // width: poToRem(146);
            height: poToRem(24);
            margin: poToRem(10) auto poToRem(32);
            
        }
        p {
            line-height: poToRem(16);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/base/mobile/mBottom.vue